var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 594,
    height: 469,
    viewBox: "0 0 594 469",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M74.9654 381.599H15.6357C-0.242362 365.082 -4.48267 338.753 5.00041 317.884C14.0341 297.996 33.4496 284.849 45.2027 266.438C70.2988 227.147 58.1655 168.615 92.2608 136.849C109.303 120.967 133.811 116.384 157.018 114.526C180.224 112.668 204.203 112.725 225.658 103.687C252.113 92.5488 272.059 68.6209 299.321 59.6062C329.925 49.4833 366.533 62.1109 384.416 88.9706C395.604 105.777 399.833 126.888 413.061 142.136C434.458 166.779 472.16 168.696 498.846 187.464C517.156 200.334 529.508 221.365 531.87 243.642C534.716 270.548 524.518 301.101 540.627 322.813C548.474 333.397 561.206 339.376 569.664 349.476C578.098 359.553 580.472 368.729 577.81 381.599H74.9654Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M90.118 381.599H30.7998C14.9217 365.082 10.6814 338.753 20.1645 317.884C29.1982 297.996 48.6137 284.849 60.3667 266.438C85.4629 227.147 73.3296 168.615 107.425 136.849C124.467 120.967 148.975 116.384 172.182 114.526C195.388 112.668 219.367 112.725 240.822 103.687C267.277 92.5488 287.223 68.6209 314.485 59.6062C345.089 49.4833 381.697 62.1109 399.58 88.9706C410.768 105.777 414.997 126.888 428.225 142.136C449.622 166.779 487.324 168.696 514.01 187.464C532.32 200.334 544.672 221.365 547.034 243.642C549.88 270.548 539.683 301.101 555.791 322.813C563.638 333.397 576.37 339.376 584.828 349.476C593.263 359.553 595.636 368.729 592.974 381.599H90.118Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.649 178.114L224.206 178.195H3.59522L3.06518 178.264C0.875897 163.605 12.3293 148.715 26.7441 144.768C39.3498 141.316 54.0986 144.387 64.6533 136.665C74.1133 129.751 76.464 116.823 82.6516 106.862C86.5001 100.663 91.9849 95.4921 98.4029 92.0408C106.446 87.7124 116.482 86.2003 124.732 90.1132C139.343 97.0619 142.143 116.453 151.914 129.37C154.091 132.255 156.834 134.945 160.325 135.903C163.54 136.792 166.951 136.099 170.246 135.51C181.043 133.606 193.994 133.779 200.712 142.459C203.869 146.545 204.998 151.785 206.75 156.633C208.501 161.493 211.37 166.479 216.221 168.222C218.549 169.042 221.187 169.065 223.238 170.438C225.704 172.089 226.499 175.032 226.649 178.114Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.51 206.013H324.245C322.194 203.312 321.941 199.133 323.404 195.925C325.305 191.711 329.269 188.849 333.221 186.471C337.173 184.082 341.379 181.889 344.34 178.345C350.021 171.546 349.687 161.793 350.943 153.021C352.418 142.609 356.773 132.302 364.632 125.318C367.743 122.548 371.349 120.355 375.129 118.6C385.902 113.579 399.245 112.321 409.316 118.647C418.949 124.695 423.673 136.203 432.073 143.879C434.055 145.703 436.325 147.33 438.952 147.942C446.477 149.673 452.872 142.84 458.518 137.565C466.537 130.074 477.253 124.476 488.131 125.872C500.921 127.534 510.807 138.523 515.658 150.493C517.686 155.479 519.23 160.997 523.263 164.54C533.61 173.624 551.078 163.444 563.143 170.046C567.671 172.528 570.701 177.041 573.121 181.612C577.154 189.241 580 197.506 581.51 206.013Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.568 349.003H203.063V381.588H158.229V349.003H91.2021V315.61L161.098 213.239H203.052V315.033H221.557V349.003H221.568ZM158.229 315.021V295.445C158.229 291.763 158.367 286.788 158.632 280.532C158.897 274.276 159.105 270.998 159.266 270.686H157.998C155.394 276.596 152.445 282.125 149.149 287.273L130.529 315.021H158.229Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.32 349.003H190.814V381.588H145.98V349.003H78.9648V315.61L148.861 213.239H190.814V315.033H209.32V349.003ZM145.98 315.033V295.457C145.98 291.775 146.118 286.8 146.383 280.544C146.648 274.287 146.856 271.009 147.017 270.698H145.75C143.146 276.608 140.196 282.136 136.9 287.284L118.28 315.033H145.98Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.126 350.122L507.685 316.764L495.667 319.096L489.514 320.285L470.225 220.337L429.021 228.325L379.808 342.123L386.133 374.916L451.939 362.161L455.684 381.588H501.348L495.955 353.643L502.108 352.454L514.126 350.122ZM433.48 331.146L418.305 334.078L429.136 308.477L431.325 303.294C433.583 297.615 435.427 291.624 436.867 285.322L438.112 285.091C438.02 285.414 438.434 288.681 439.356 294.879C440.278 301.066 441.085 305.972 441.788 309.596L445.498 328.815L433.48 331.146Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.108 352.454L495.667 319.108L477.495 322.628L458.195 222.68L429.02 228.325L417.002 230.656L367.789 344.467L374.115 377.248L386.133 374.916L439.92 364.505L443.216 381.588H488.88L483.937 355.975L495.955 353.643L502.108 352.454ZM429.135 308.477C429.354 309.735 429.573 310.878 429.769 311.928L433.479 331.146L406.274 336.421L419.306 305.626C421.565 299.958 423.408 293.968 424.849 287.665L426.093 287.423C426.001 287.758 426.416 291.024 427.338 297.211C427.994 301.62 428.594 305.383 429.135 308.477Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.823 296.195H200.457L183.07 168.661C183.07 168.661 157.95 141.166 129.109 136.018L156.579 133.052L218.49 134.737L227.823 296.195Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.799 226.085C119.799 226.085 104.244 248.894 111.146 268.47L140.079 226.085L136.323 221.03L119.799 226.085Z",
    fill: "#CBCEDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.457 296.195L199.524 302.082C199.524 302.082 191.273 303.236 190.812 315.033H212.256L223.905 303.64L224.988 296.195H200.457Z",
    fill: "#CBCEDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.341 168.569L133.039 167.287L138.616 219.91L115.363 228.255L101.962 163.27C98.0447 151.162 106.237 138.5 118.866 137.126L129.086 136.018H129.098C157.939 141.166 183.058 168.661 183.058 168.661L167.341 168.569Z",
    fill: "#2A293B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.175 21.7002V23.2354L102.32 23.4778C101.847 22.4505 101.329 21.631 100.822 21.1808C98.3443 19.0339 96.6159 17.3486 94.8415 18.3759C93.5049 19.1608 93.6086 22.8314 93.7353 24.5628L88.6769 25.2092L43.8541 30.8997L43.8311 30.8189C46.7347 30.1263 48.9932 24.9091 48.9932 18.5606C48.9932 12.293 46.8039 7.13342 43.9578 6.32544L104.186 13.1356V14.3476V21.7002H104.175Z",
    fill: "#35A5B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1844 9.60349C47.0577 9.78817 46.9425 9.97286 46.8387 10.1806C46.1935 11.4272 45.8939 12.8585 45.0988 14.0012C44.5227 14.8554 43.67 15.5133 42.7252 15.8827C41.7227 16.2751 40.6166 16.3444 39.5334 16.4829C38.819 16.5752 38.0816 16.7253 37.4248 17.0254C37.7705 11.0348 40.1211 6.37156 43.0248 6.20996L43.9581 6.31384C45.191 6.67167 46.3202 7.86056 47.1844 9.60349Z",
    fill: "#D9EDF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9704 17.5449C48.9474 17.5679 48.9359 17.591 48.9128 17.6026C48.1754 18.5952 47.8182 19.8303 47.1383 20.846C46.3433 22.0465 45.0643 22.9122 43.6585 23.2354C42.3565 23.5239 40.9622 23.3739 39.7754 23.9626C39.1762 24.2742 38.6808 24.759 38.3236 25.3246C37.7244 23.3739 37.3672 21.0423 37.3672 18.5375C37.3672 18.0181 37.3787 17.5102 37.4248 17.0024C38.0816 16.7022 38.819 16.5522 39.5334 16.4598C40.6166 16.3098 41.7112 16.2521 42.7252 15.8596C43.6816 15.4903 44.5227 14.8323 45.0988 13.9782C45.8939 12.8355 46.205 11.4042 46.8387 10.1576C46.9424 9.96135 47.0577 9.77667 47.1844 9.58044C48.1869 11.6466 48.8552 14.4168 48.9704 17.5449Z",
    fill: "#68CDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9931 18.5491C48.9931 24.8975 46.7347 30.1263 43.831 30.8073C43.6236 30.865 43.3932 30.8881 43.1742 30.8881C41.1463 30.8881 39.3603 28.6835 38.3232 25.3361C38.692 24.759 39.1759 24.2858 39.7751 23.9741C40.9619 23.3854 42.3677 23.5355 43.6582 23.2469C45.0639 22.9237 46.343 22.0465 47.138 20.8576C47.8294 19.8418 48.175 18.5952 48.9125 17.6141C48.9355 17.591 48.9471 17.5679 48.9701 17.5564C48.9816 17.8796 48.9931 18.2143 48.9931 18.5491Z",
    fill: "#D9EDF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.665 15.5365H157.778C155.889 16.2983 154.275 17.164 153.55 17.845C152.973 18.376 153.227 19.3456 153.93 20.5806H139.653V15.5365H139.665Z",
    fill: "#111023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.82 18.5722V20.5806H170.003C169.058 18.3991 168.355 16.5523 168.113 15.5365H179.82V18.5722Z",
    fill: "#111023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.665 20.5806V21.7003H104.176V14.3361H139.665V15.5365V20.5806Z",
    fill: "#D9EDF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.582 34.2701L97.7692 40.2261C97.7692 40.2261 88.2862 30.2648 88.6664 25.2091L93.7248 24.5627C93.5981 22.8198 93.4944 19.1492 94.831 18.3759C96.6055 17.3486 98.3339 19.0338 100.811 21.1807C101.318 21.6309 101.825 22.4504 102.309 23.4777C104.141 27.3907 105.582 34.2701 105.582 34.2701Z",
    fill: "#FFB9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0032 6.36006C52.4847 5.21734 50.7909 6.19846 51.3094 7.32964C54.5242 14.3706 54.1094 22.1157 50.2608 28.822C49.6386 29.907 51.3209 30.8881 51.9431 29.8031C56.1604 22.4736 56.506 14.0359 53.0032 6.36006Z",
    fill: "#9EE6ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.15 42.1307V48.1675L184.937 41.3342L192.15 42.1307Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.15 48.1674L199.409 55.0353L206.334 61.5915C206.334 61.5915 222.212 50.4529 228.365 50.3605C228.803 50.349 229.218 50.3836 229.621 50.4413C235.06 51.2147 238.378 57.5054 237.422 63.5422C236.396 70.0522 236.581 77.2433 230.324 78.4091C224.067 79.5865 196.517 86.2812 196.517 86.2812L166.362 45.2933L169.911 42.8117L177.827 37.2596L179.429 36.14L182.909 39.4297L184.925 41.3342L192.15 48.1674Z",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.623 43.3888L229.633 50.4413C229.23 50.3836 228.815 50.349 228.377 50.3605C222.213 50.4529 206.346 61.5915 206.346 61.5915L199.421 55.0353L211.623 43.3888Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.335 78.4206L219.873 106.954L218.467 134.737C218.467 134.737 217.246 134.956 215.114 135.257C205.136 136.688 175.246 140.093 156.556 133.052L163.839 98.5279L160.474 71.2988L119.857 75.8004L94.3691 42.8116L97.7683 40.2145L105.581 34.2585L129.674 57.8286L167.376 41.3226C168.747 42.3153 169.934 42.8001 169.934 42.8001L166.385 45.2817L196.54 86.2696C196.528 86.2812 224.09 79.5864 230.335 78.4206Z",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.838 37.2712L169.922 42.8232C169.922 42.8232 168.735 42.3384 167.364 41.3458C165.578 40.0645 163.47 37.9522 163.205 34.9742C162.859 30.9805 156.13 24.4704 153.929 20.5921C153.226 19.3571 152.973 18.3875 153.549 17.8565C154.275 17.164 155.888 16.3098 157.778 15.548C161.96 13.8859 167.549 12.7431 168.056 15.3402C168.067 15.3979 168.09 15.4787 168.113 15.548C168.355 16.5637 169.058 18.4106 170.003 20.5921C172.872 27.2868 177.838 37.2712 177.838 37.2712Z",
    fill: "#FFB9B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M219.872 106.954C173.724 97.1429 166.373 45.3049 166.373 45.3049L196.539 86.3159L230.346 78.4207L219.872 106.954Z",
    fill: "url(#paint12_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.357 18.1912C212.337 17.9257 213.316 18.1219 213.719 19.6802C214.63 23.2469 210.631 27.5407 210.631 27.5407L211.622 43.3887L199.42 55.0352L204.202 41.3342L192.161 42.1306L184.948 41.3342L182.931 39.4296C182.931 39.4296 181.525 26.2826 181.525 18.5721C181.525 16.7945 181.595 15.3055 181.79 14.3359L181.848 13.9666C190.283 15.3979 201.989 12.0967 201.989 12.0967C201.989 12.0967 203.626 28.1063 205.873 28.3833C208.12 28.6488 208.811 19.6802 208.811 19.6802C208.811 19.6802 210.09 18.5375 211.357 18.1912Z",
    fill: "#FFB9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.45 6.55624L211.358 18.1912C210.09 18.5375 208.811 19.6802 208.811 19.6802C208.811 19.6802 208.12 28.6488 205.873 28.3833C203.626 28.1063 201.99 12.0967 201.99 12.0967C201.99 12.0967 190.283 15.3979 181.848 13.9666V13.9551C179.198 13.5164 176.882 12.6046 175.35 10.9771C168.897 4.16692 171.144 0.311684 180.385 2.41244C189.626 4.5132 208.788 -6.63698 211.45 6.55624Z",
    fill: "#111023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.191 41.3342L199.409 55.0353L192.149 48.1675V42.1307L204.191 41.3342Z",
    fill: "#E6A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.042 16.0789C182.897 15.144 184.833 15.0401 186.78 15.7442C187.967 16.1713 187.068 17.9373 185.893 17.5102C184.66 17.0716 183.277 17.1524 182.113 17.7411C180.984 18.2951 179.901 16.6445 181.042 16.0789Z",
    fill: "#111023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.061 22.8542C199.843 22.8133 200.427 21.8409 200.367 20.6823C200.306 19.5237 199.624 18.6176 198.842 18.6586C198.06 18.6995 197.476 19.6719 197.536 20.8305C197.597 21.9891 198.279 22.8951 199.061 22.8542Z",
    fill: "#111023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.425 15.6057C199.477 14.867 197.553 14.9593 195.675 15.8712C194.534 16.4252 195.606 18.0758 196.735 17.5333C197.91 16.9677 199.305 16.91 200.526 17.3717C201.713 17.8103 202.612 16.0558 201.425 15.6057Z",
    fill: "#111023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.759 27.2637C188.392 24.2857 189.925 21.25 190.962 18.3759C191.181 17.7757 192.057 18.2259 191.838 18.8145C191.181 20.6267 190.524 22.4274 189.867 24.2396C189.637 24.8629 189.084 25.9017 189.026 26.5596C188.807 28.8104 189.844 28.6373 191.008 29.1798C191.584 29.4453 191.135 30.3341 190.57 30.057C189.141 29.3991 187.321 29.3183 187.759 27.2637Z",
    fill: "#E6A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.676 21.0076C185.755 20.2689 184.706 19.7725 183.531 19.6225C182.805 19.5301 182.505 20.6498 183.243 20.7421C183.842 20.8229 184.395 20.9845 184.925 21.2384C184.314 21.4347 183.692 21.6424 183.081 21.8387C182.378 22.0695 182.678 23.1891 183.381 22.9583C184.395 22.6236 185.409 22.3004 186.423 21.9656C186.78 21.8502 187.034 21.2962 186.676 21.0076Z",
    fill: "#111023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.435 39.776C192.848 39.776 193.993 38.1171 193.993 36.0708C193.993 34.0245 192.848 32.3656 191.435 32.3656C190.022 32.3656 188.877 34.0245 188.877 36.0708C188.877 38.1171 190.022 39.776 191.435 39.776Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M544.614 381.599H82.259C82.259 381.599 57.3818 398.14 94.3692 400.945C131.357 403.749 189.039 406.393 187.621 418.997C186.204 431.602 152.8 429.109 152.8 451.363C152.8 473.617 306.857 468.48 306.857 468.48C306.857 468.48 393.887 469.623 406.285 454.883C418.684 440.155 371.199 426.662 379.818 420.856C388.437 415.05 450.993 432.479 460.315 418.362C469.636 404.257 458.448 395.323 475.64 393.465C492.831 391.607 541.71 398.359 544.614 381.599Z",
    fill: "url(#paint13_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.654 420.867C528.961 420.867 544.613 416.407 544.613 410.906C544.613 405.404 528.961 400.945 509.654 400.945C490.346 400.945 474.694 405.404 474.694 410.906C474.694 416.407 490.346 420.867 509.654 420.867Z",
    fill: "#EEEFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.463 427.089C154.34 427.089 168.021 423.699 168.021 419.517C168.021 415.335 154.34 411.945 137.463 411.945C120.586 411.945 106.905 415.335 106.905 419.517C106.905 423.699 120.586 427.089 137.463 427.089Z",
    fill: "#EEEFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.607 455.726C331.775 455.726 347.313 452.729 347.313 449.031C347.313 445.334 331.775 442.336 312.607 442.336C293.44 442.336 277.901 445.334 277.901 449.031C277.901 452.729 293.44 455.726 312.607 455.726Z",
    fill: "#EDEEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.502 292.525C351.381 276.215 338.026 266.058 318.438 262.052C316.306 261.614 314.221 261.268 312.181 261.014C294.897 258.821 280.644 262.953 269.421 273.41C256.861 285.092 247.597 305.603 241.605 334.944C237.941 352.916 236.916 368.464 238.54 381.588H281.358C280.817 373.924 282.326 361.388 285.875 344.005C289.712 325.202 293.514 312.505 297.282 305.903C299.472 302.071 301.949 299.543 304.714 298.319C306.708 297.431 308.863 297.223 311.156 297.696C316.64 298.827 319.797 303.294 320.627 311.097C321.457 318.911 320.005 331.955 316.283 350.227C313.483 363.928 310.672 374.374 307.86 381.588H354.803C356.981 374.835 358.894 367.402 360.541 359.288C361.636 353.92 362.5 348.772 363.122 343.844C365.807 322.836 364.263 305.73 358.502 292.525Z",
    fill: "url(#paint14_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.507 290.078C340.112 275.43 328.67 265.734 312.181 261.014C310.326 260.483 308.413 260.009 306.431 259.605C286.313 255.485 269.974 259.271 257.414 270.963C244.866 282.656 235.591 303.167 229.61 332.497C228.389 338.465 227.467 344.178 226.834 349.615C225.439 361.561 225.451 372.227 226.88 381.588H269.64C269.582 381.311 269.548 381.034 269.513 380.745C268.614 373.277 270.066 360.211 273.869 341.558C277.706 322.755 281.508 310.058 285.288 303.467C289.055 296.865 293.676 294.129 299.161 295.26C301.408 295.722 303.263 296.738 304.715 298.319C306.846 300.605 308.137 304.044 308.632 308.65C309.462 316.464 308.01 329.507 304.288 347.779C301.154 363.108 298.008 374.374 294.851 381.588H342.013C344.502 374.2 346.68 365.959 348.546 356.852C354.296 328.642 353.616 306.388 346.507 290.078Z",
    fill: "url(#paint15_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.197 180.077L378.909 180.296L348.801 203.774L330.007 218.421L314.36 261.798L310.016 260.229L326.136 215.593L376.374 176.429L379.197 180.077Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.624 277.427C390.201 281.502 385.535 284.295 380.96 287.007L380.649 286.465C382.458 284.145 384.371 281.421 383.829 278.524C383.449 276.55 381.997 274.98 380.511 273.653C377.987 271.425 375.176 269.543 372.768 267.2C370.36 264.857 368.32 261.914 367.928 258.578C367.421 254.192 369.783 250.048 370.705 245.731C371.074 244 371.201 242.153 370.509 240.525C368.965 236.855 364.299 236.012 360.6 234.535C357.293 233.196 354.182 230.714 353.26 227.263C351.923 222.253 355.484 217.128 355 211.969C354.666 208.368 352.108 205.147 348.801 203.774L378.909 180.296C384.014 184.728 388.415 190.603 388.473 197.31C388.496 201.557 386.779 205.597 385.558 209.66C385.074 211.299 384.659 213.008 384.959 214.681C385.431 217.244 387.471 219.183 389.349 220.995C393.232 224.723 397.138 229.26 397.069 234.65C397 240.698 391.849 246.089 392.748 252.068C393.324 255.889 396.262 258.936 397.438 262.606C399.051 267.685 397.046 273.353 393.624 277.427Z",
    fill: "#50A8B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 286.696,
    y1: 397.768,
    x2: 305.404,
    y2: 115.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45A3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 301.857,
    y1: 397.768,
    x2: 320.564,
    y2: 115.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 114.726,
    y1: 179.039,
    x2: 114.726,
    y2: 129.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 451.304,
    y1: 213.562,
    x2: 454.422,
    y2: 165.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 91.2074,
    y1: 297.408,
    x2: 221.567,
    y2: 297.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50A8B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 145.331,
    y1: 392.675,
    x2: 144.084,
    y2: 329.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9E6D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FCF1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2698,
    stopColor: "#FEF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    stopColor: "#FFFEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 375.966,
    y1: 322.234,
    x2: 503.974,
    y2: 297.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50A8B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 435.702,
    y1: 386.971,
    x2: 434.455,
    y2: 323.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9E6D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FCF1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2698,
    stopColor: "#FEF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    stopColor: "#FFFEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 188.617,
    y1: 42.0977,
    x2: 188.055,
    y2: 62.4909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37A9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#126E78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 202.337,
    y1: 42.366,
    x2: 200.838,
    y2: 89.7006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38AEBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B636C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 214.795,
    y1: 42.8194,
    x2: 214.233,
    y2: 63.2125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38AEBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#167580"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 94.3676,
    y1: 85.8086,
    x2: 230.339,
    y2: 85.8086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38AEBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#226C74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 166.373,
    y1: 76.1262,
    x2: 230.339,
    y2: 76.1262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A5A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A7780"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 308.11,
    y1: 472.132,
    x2: 309.357,
    y2: 386.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#88C8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5395F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 245.656,
    y1: 315.076,
    x2: 364.602,
    y2: 339.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50A8B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 289.988,
    y1: 389.834,
    x2: 288.741,
    y2: 326.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9E6D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FCF1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2698,
    stopColor: "#FEF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    stopColor: "#FFFEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 594,
    height: 469,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError404);
export default __webpack_public_path__ + "static/media/error404.d916c7d4610e9e5d8a43310bf9c16fb4.svg";
export { ForwardRef as ReactComponent };